/* eslint-disable jsx-a11y/alt-text */
import { Grid, Box, Typography, Divider } from '@material-ui/core';
import React from 'react';
import { moneyFormat, simpleDateFormatter2 } from '../Shared/colorFormat';
import _ from 'lodash';

const RH = 36;

const receiptColor = '#008000';
const invoiceColor = '#000080';
const purchaseColor = '#660066';
const expenseColor = '#ff6666';

const renderBox = (
  title: any,
  number = false,
  bold = false,
  height = RH,
  fontSize = undefined,
  color = undefined
) => {
  return (
    <Box
      border={1}
      borderColor="grey.300"
      style={{
        paddingLeft: 8,
        paddingRight: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: number ? 'flex-end' : 'flex-start',
        height,
      }}
    >
      <Typography
        style={{
          fontWeight: bold ? 'bold' : undefined,
          fontSize,
          color,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export class ContractPrintFree extends React.PureComponent<any, any> {
  renderFooter = (data: any) => {
    const { row, isRTL } = data;
    return (
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={1}></Grid>
          <Grid item xs={5}>
            <Typography style={{ fontSize: 16 }}>
              {isRTL ? 'الاسم' : 'Name'}: {row.name}
            </Typography>
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={12} style={{ height: 10 }}></Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={5}>
            <Typography style={{ fontSize: 16 }}>
              {isRTL ? 'التوقيع' : 'Sign'}: ...............................
            </Typography>
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
      </Grid>
    );
  };
  renderHeader = (company: any) => (
    <Grid item xs={12}>
      <img
        src={company?.header}
        alt={company?.name}
        height="auto"
        width="100%"
        style={{
          objectFit: 'contain',
        }}
      />
      <Divider></Divider>
    </Grid>
  );

  renderTitle = (printData: any) => {
    const { isRTL, data } = printData;
    if (!data) return <></>;
    const contract = data?.contract;
    const contracts = data?.contracts;
    const amounts = _.sumBy(contracts, 'amount') || 0;

    const {
      customerName,
      customerPhone,
      printdate,
      title,
      resourseName,
      start,
      amount,
    } = contract;
    const total = amount + amounts;
    return (
      <Grid item xs={12}>
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ marginBottom: 40, marginTop: 20 }}>
            <Typography style={{ textAlign: 'center' }} variant="h3">
              {isRTL ? 'بطاقة العقد ' : 'Contract Data'}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {renderBox(isRTL ? 'تاريخ التعاقد' : 'Date', false, true, 40)}
          </Grid>
          <Grid item xs={4}>
            {renderBox(simpleDateFormatter2(printdate), false, true, 40)}
          </Grid>
          <Grid item xs={2}>
            {renderBox(isRTL ? 'تاريخ العرس' : 'Date', false, true, 40)}
          </Grid>
          <Grid item xs={4}>
            {renderBox(simpleDateFormatter2(start), false, true, 40)}
          </Grid>
          <Grid item xs={2}>
            {renderBox(isRTL ? 'اسم المتعاقد' : 'Customer', false, true, 40)}
          </Grid>
          <Grid item xs={4}>
            {renderBox(customerName, false, true, 40)}
          </Grid>
          <Grid item xs={2}>
            {renderBox(isRTL ? 'رقم الهاتف' : 'Phone', false, true, 40)}
          </Grid>
          <Grid item xs={4}>
            {renderBox(customerPhone, false, true, 40)}
          </Grid>
          <Grid item xs={2}>
            {renderBox(isRTL ? 'رقم العقد' : 'Contract No', false, true, 40)}
          </Grid>
          <Grid item xs={4}>
            {renderBox(title, false, true, 40)}
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={2}>
            {renderBox(isRTL ? 'مكان الحفل' : 'Location', false, true, 40)}
          </Grid>
          <Grid item xs={4}>
            {renderBox(resourseName, false, true, 40)}
          </Grid>
          <Grid item xs={2} style={{ backgroundColor: `${receiptColor}22` }}>
            {renderBox(isRTL ? 'قيمة العقد' : 'Amount', false, true, 40)}
          </Grid>
          <Grid item xs={4} style={{ backgroundColor: `${receiptColor}22` }}>
            {renderBox(moneyFormat(amount), false, true, 40)}
          </Grid>
          {contracts && contracts.length > 0 && (
            <>
              <Grid item xs={12}>
                <Box style={{ height: 30 }}>
                  <Typography
                    style={{
                      fontSize: 18,
                      fontWeight: 'bold',
                      marginTop: 20,
                    }}
                  >
                    {isRTL ? 'العقود الاضافية' : 'Extra Contracts'}
                  </Typography>
                </Box>
              </Grid>
              {contracts.map((item: any, index: number) => (
                <Grid item xs={12} key={index}>
                  <Grid container spacing={0}>
                    <Grid item xs={2}>
                      {renderBox(
                        simpleDateFormatter2(item.printdate),
                        false,
                        true,
                        40
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {renderBox(item.title, false, true, 40)}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{ backgroundColor: `${receiptColor}22` }}
                    >
                      {renderBox(
                        isRTL ? 'قيمة العقد' : 'Amount',
                        false,
                        true,
                        40
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ backgroundColor: `${receiptColor}22` }}
                    >
                      {renderBox(moneyFormat(item.amount), false, true, 40)}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
              <Grid item xs={12}>
                <Box style={{ height: 20 }}></Box>
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid
                item
                xs={2}
                style={{ backgroundColor: `${receiptColor}22` }}
              >
                {renderBox(
                  isRTL ? 'قيمة العقود' : 'Total Amount',
                  false,
                  true,
                  40,
                  18,
                  receiptColor
                )}
              </Grid>
              <Grid
                item
                xs={4}
                style={{ backgroundColor: `${receiptColor}22` }}
              >
                {renderBox(
                  moneyFormat(total),
                  false,
                  true,
                  40,
                  18,
                  receiptColor
                )}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    );
  };

  renderRow = (
    title: any,
    value: any,
    min = false,
    isRTL: any,
    bgcolr = undefined,
    color = false
  ) => {
    return (
      <Grid
        item
        xs={12}
        style={{ backgroundColor: bgcolr ? `${bgcolr}11` : undefined }}
      >
        <Grid container spacing={0}>
          <Grid item xs={6}>
            {renderBox(
              title,
              false && !isRTL,
              true,
              RH,
              undefined,
              color ? bgcolr : undefined
            )}
          </Grid>
          {min === true && (
            <>
              <Grid item xs={3}>
                {renderBox(
                  moneyFormat(value),
                  true && !isRTL,
                  true,
                  RH,
                  13,
                  color ? bgcolr : undefined
                )}
              </Grid>
              <Grid item xs={3}>
                {renderBox('', true && !isRTL, true)}
              </Grid>
            </>
          )}
          {min === false && (
            <>
              <Grid item xs={3}>
                {renderBox('')}
              </Grid>
              <Grid item xs={3}>
                {renderBox(
                  moneyFormat(value),
                  true && !isRTL,
                  true,
                  RH,
                  13,
                  color ? bgcolr : undefined
                )}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    );
  };
  renderTotalRow = ({
    title,
    value,
    value2,
    isRTL,
    bgcolr = undefined,
    color = false,
  }: any) => {
    return (
      <Grid
        item
        xs={12}
        style={{ backgroundColor: bgcolr ? `${bgcolr}11` : undefined }}
      >
        <Grid container spacing={0}>
          <Grid item xs={6}>
            {renderBox(
              title,
              false && !isRTL,
              true,
              RH,
              undefined,
              color ? bgcolr : undefined
            )}
          </Grid>
          <Grid item xs={3}>
            {renderBox(
              moneyFormat(value),
              true && !isRTL,
              true,
              RH,
              13,
              color ? bgcolr : undefined
            )}
          </Grid>
          <Grid item xs={3}>
            {renderBox(
              moneyFormat(value2),
              true && !isRTL,
              true,
              RH,
              13,
              color ? bgcolr : undefined
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderListCredit = (
    title: any,
    list: any,
    isRTL: any,
    bgcolor = undefined
  ) => {
    return (
      <Grid
        item
        xs={12}
        style={{ backgroundColor: bgcolor ? `${bgcolor}11` : undefined }}
      >
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {renderBox(title, false && !isRTL, true, 40, 20, bgcolor)}
          </Grid>
          {list.map((item: any, index: number) => {
            const desc = `${item.docNo} / ${item?.desc || item?.supplierName}`;
            return (
              <Grid item xs={12} key={index}>
                <Grid container spacing={0}>
                  <Grid item xs={2}>
                    {renderBox(simpleDateFormatter2(item.time))}
                  </Grid>
                  <Grid item xs={4}>
                    {renderBox(desc, false && !isRTL, false, 36, 13)}
                  </Grid>
                  <Grid item xs={3}>
                    {renderBox('', true && !isRTL)}
                  </Grid>
                  <Grid item xs={3}>
                    {renderBox(moneyFormat(item.amount), true && !isRTL)}
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    );
  };
  renderListDebit = (
    title: any,
    list: any,
    isRTL: any,
    bgcolor = undefined
  ) => {
    return (
      <Grid
        item
        xs={12}
        style={{ backgroundColor: bgcolor ? `${bgcolor}11` : undefined }}
      >
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {renderBox(title, false && !isRTL, true, 40, 20, bgcolor)}
          </Grid>
          {list.map((item: any, index: number) => (
            <Grid item xs={12} key={index}>
              <Grid container spacing={0}>
                <Grid item xs={2}>
                  {renderBox(simpleDateFormatter2(item.time))}
                </Grid>
                <Grid item xs={4}>
                  {renderBox(item.contractName)}
                </Grid>
                <Grid item xs={3}>
                  {renderBox(moneyFormat(item.amount), true && !isRTL)}
                </Grid>
                <Grid item xs={3}>
                  {renderBox('', true && !isRTL)}
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  };

  renderDetails = (printData: any) => {
    const { isRTL, data } = printData;
    if (!data) return <></>;
    const {
      // totalpaid = 0,
      // totalDiscount = 0,
      // totalPurchaseInvoiced = 0,
      // toatlExpenses = 0,
      invoices,
      receipts,
      expenses,
      purchses,
    } = data;

    const totalInvoices = _.sumBy(invoices, 'amount') || 0;
    const totalDiscounts = _.sumBy(invoices, 'discount') || 0;
    const totalReceipts = _.sumBy(receipts, 'amount') || 0;
    const totalPurchases = _.sumBy(purchses, 'amount') || 0;
    const totalExpenses = _.sumBy(expenses, 'amount') || 0;
    const totalplus = totalInvoices;
    const totalminus = totalDiscounts + totalPurchases + totalExpenses;
    const netprofit = totalplus - totalminus;
    const notpaid = totalInvoices - totalReceipts - totalDiscounts;

    return (
      <Grid item xs={12}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Grid container spacing={0} className="avoid-page-break">
              {this.renderListDebit(
                isRTL ? 'الفواتير' : 'Invoices',
                invoices,
                isRTL,
                invoiceColor
              )}
              {this.renderRow(
                isRTL ? 'مجموع الفواتير' : 'Total Invoices',
                totalInvoices,
                true,
                isRTL,
                invoiceColor
              )}
              {this.renderRow(
                isRTL ? 'الخصومات' : 'Total Discount',
                totalDiscounts,
                false,
                isRTL,
                invoiceColor
              )}
              {this.renderRow(
                isRTL ? 'صافي الفواتير' : 'Net Invoices',
                totalInvoices - totalDiscounts,
                true,
                isRTL,
                invoiceColor,
                true
              )}
              <Grid item xs={12}>
                <Box style={{ height: 50 }}> </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={0} className="avoid-page-break">
              {this.renderListCredit(
                isRTL ? 'المقبوضات' : 'Receipts',
                receipts,
                isRTL,
                receiptColor
              )}
              {this.renderRow(
                isRTL ? 'مجموع المقبوضات' : 'Total Receipts',
                totalReceipts,
                false,
                isRTL,
                receiptColor,
                true
              )}
              {this.renderRow(
                isRTL ? 'غير مقبوض' : 'Not Paid',
                notpaid,
                true,
                isRTL,
                receiptColor,
                true
              )}
              <Grid item xs={12}>
                <Box style={{ height: 50 }}> </Box>
              </Grid>
            </Grid>
          </Grid>
          {totalPurchases > 0 && (
            <Grid item xs={12}>
              <Grid container spacing={0} className="avoid-page-break">
                {this.renderListCredit(
                  isRTL ? 'المشتريات' : 'Purchases',
                  purchses,
                  isRTL,
                  purchaseColor
                )}
                {this.renderRow(
                  isRTL ? 'مجموع المشتريات' : 'Total Purchases',
                  totalPurchases,
                  false,
                  isRTL,
                  purchaseColor,
                  true
                )}
                <Grid item xs={12}>
                  <Box style={{ height: 50 }}> </Box>
                </Grid>
              </Grid>
            </Grid>
          )}
          {totalExpenses > 0 && (
            <Grid item xs={12}>
              <Grid container spacing={0} className="avoid-page-break">
                {this.renderListCredit(
                  isRTL ? 'المصروفات' : 'Expenses',
                  expenses,
                  isRTL,
                  expenseColor
                )}
                {this.renderRow(
                  isRTL ? 'مجموع المصروفات' : 'Total Expenses',
                  totalExpenses,
                  false,
                  isRTL,
                  expenseColor,
                  true
                )}
                <Grid item xs={12}>
                  <Box style={{ height: 50 }}> </Box>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container spacing={0} className="avoid-page-break">
              {this.renderRow(
                isRTL ? 'الفواتير' : 'Invoices',
                totalplus,
                true,
                isRTL,
                invoiceColor,
                true
              )}
              {totalDiscounts > 0 &&
                this.renderRow(
                  isRTL ? 'الخصومات' : 'Discount',
                  totalDiscounts,
                  false,
                  isRTL,
                  invoiceColor
                )}
              {totalExpenses > 0 &&
                this.renderRow(
                  isRTL ? 'المصروفات' : 'Expenses',
                  totalExpenses,
                  false,
                  isRTL,
                  expenseColor,
                  true
                )}
              {totalPurchases > 0 &&
                this.renderRow(
                  isRTL ? 'المشتريات' : 'Purchases',
                  totalPurchases,
                  false,
                  isRTL,
                  purchaseColor,
                  true
                )}
              {this.renderTotalRow({
                title: isRTL ? 'المجموع' : 'Total',
                value: totalplus,
                value2: totalminus,
                isRTL,
                bgcolr: undefined,
                color: true,
              })}
              {this.renderRow(
                isRTL ? 'صافي الربح' : 'Net Profit',
                netprofit,
                true,
                isRTL,
                receiptColor,
                true
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  renderDivider = (x: number) => (
    <Grid item xs={12}>
      <Box m={x}></Box>
    </Grid>
  );
  render() {
    const { company, printData } = this.props;
    const { isRTL } = printData;
    return (
      <table className="report-container">
        <thead className="report-header">
          <tr>
            <th className="report-header-cell">
              <div className="header-info">{this.renderHeader(company)}</div>
            </th>
          </tr>
        </thead>
        <tbody className="report-content">
          <tr>
            <td className="report-content-cell">
              <div className="main">
                <Box style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Box ml={8} mr={8}>
                        <Grid container spacing={2}>
                          {this.renderDivider(1)}
                          {this.renderTitle(printData)}
                          {this.renderDivider(1)}
                          {this.renderDetails(printData)}
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot className="report-footer">
          <tr>
            <td className="report-footer-cell">
              <div className="footer-info">
                <div className={'page-footer'}></div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }
}
